export default "__VITE_ASSET__ba8c6c07__"